import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Config } from "../../Config";
import { Helmet } from "react-helmet";
import Slider from "../../components/MainSlider/MainSlider";
import ProductSlider from "../../components/ProductSlider/ProductSlider";
import Banner from "../../components/Banner/Banner";
import Skeleton from "react-loading-skeleton";
import fakeBannerImg from "../../assets/images/fake/banner.jpg";
import BannerImage from "../../components/BannerImage/BannerImage";
import MarketsSlider from "../../components/MarketsSlider/MarketsSlider";
import swal from "sweetalert";
import "./Main.scss";

const Main = (props) => {
  const [topSlider, setTopSlider] = useState([]);
  const [sliderNewProduct, setSliderNewProduct] = useState([]);
  const [sliderMostSeen, setSliderMostSeen] = useState([]);
  const [sliderMostSale, setSliderMostSale] = useState([]);
  const [lastMarkets, setLastMarkets] = useState([]);
  const [homeBanner, setHomeBanner] = useState([]);
  const [preloader, setPreloader] = useState(false);
  const user = useSelector((state) => state.user);

  // const fakeBanner = [
  //   {
  //     id: 1,
  //     src: fakeBannerImg,
  //     title: "first",
  //   },
  //   {
  //     id: 2,
  //     src: fakeBannerImg,
  //     title: "first",
  //   },
  //   {
  //     id: 3,
  //     src: fakeBannerImg,
  //     title: "first",
  //   },
  //   {
  //     id: 4,
  //     src: fakeBannerImg,
  //     title: "first",
  //   },
  // ];

  useEffect(async () => {
    Config.pageUp();
    await getMainInfo();
    let name = "sadrayar.ir/modal=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    let cookie;
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        cookie = c.substring(name.length, c.length);
      }
    }
    if (!cookie) {
      let myHtml = document.createElement("div");
      myHtml.innerHTML = `
      <div class="policyWrapper">
        <div style="text-align: right;margin-bottom: 10px;font-weight: bold;">
        قابل توجه متقاضیان
        </div>
        <div style="text-align: justify;">
        به اطلاع می رساند ناوگان های دارای کارت هوشمند راهداری جهت دریافت روغن موتور می بایست با کد ملی درج شده در کارت هوشمند ناوگان خود وارد سامانه شوند. لازم به ذکر است طرح توزیع روغن موتور مختص ناوگان سنگین و نیمه سنگین و سبک بوده و به صورت پایلوت از پایانه اکبر آباد تهران آغاز گردیده و به زودی مابقی مراکز نیز مشمول طرح خواهند شد.
        </div>
      </div>
      `;
      await swal({
        // icon: "warning",
        title: "باسمه تعالی",
        content: myHtml,
        button: "بستن",
        // text: "به اطلاع می رساند ناوگان های دارای کارت هوشمند راهداری جهت دریافت روغن موتور می بایست با کد ملی درج شده در کارت هوشمند ناوگان خود وارد سامانه شوند. لازم به ذکر است طرح توزیع روغن موتور فقط مختص ناوگان سنگین بوده و به صورت پایلوت از پایانه اکبر آباد تهران آغاز گردیده و به زودی مابقی مراکز نیز مشمول طرح خواهند شد.",
      }).then((willDelete) => {
        if (willDelete) {
          const d = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
          let expires = "expires=" + d.toUTCString();
          document.cookie = "sadrayar.ir/modal=true;" + expires + ";path=/";
        }
      });
    }
  }, []);
  const getMainInfo = async () => {
    setPreloader(true);

    await axios
      .get(
        "/Home/GetSliders",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setTopSlider(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
    await axios
      .get(
        "/Api/WelfareServiceCenters/Get5Latest",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setLastMarkets(result.data.data.welfareServiceCenters);
      })
      .catch((error) => {
        console.log(error);
      });

    await axios
      .get(
        "/Home/GetNewProducts",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setSliderNewProduct(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    await axios
      .get(
        "/Home/GetMostSeenProducts",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setSliderMostSeen(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    await axios
      .get(
        "/Home/GetMostSaleProducts",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setSliderMostSale(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    await axios
      .get(
        "/Home/GetHomeBanner",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setHomeBanner(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    setPreloader(false);
  };

  return (
    <section>
      <Helmet>
        <title>{Config.helmetTitle} | ارائه دهنده خدمات آنلاین خودرو در ایران</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <main>
        <h1 style={{ display: "none" }}>Iran Regalo</h1>
        {/* {topSlider.length > 0 ? (
          <Slider
            infinite={true}
            slideCount={1}
            slideSpeed={4000}
            dots={true}
            autoplay={true}
            sldeToScroll={1}
            swipeToSlide={true}
            width="100%"
            height="auto" // 600px
            sliderData={topSlider}
          />
        ) : (
          <Skeleton
            containerClassName="homeSliderSkeletonWrapper"
            highlightColor={Config.skeletonHighlightColor}
            className="skeleton"
          />
        )} */}

        <BannerImage data={topSlider} secondPart={true} />

        {/* <MarketsSlider
          title="مراکز خدمات رفاهی"
          infinite={lastMarkets.length > 4}
          slideCount={4}
          slideSpeed={4000}
          dots={false}
          autoplay={false}
          sldeToScroll={1}
          swipeToSlide={true}
          width="100%"
          height="700px" // 600px
          sliderData={lastMarkets}
        /> */}
        <ProductSlider
          title="جدیدترین محصولات"
          infinite={sliderNewProduct.length > 4}
          slideCount={4}
          slideSpeed={4000}
          dots={false}
          autoplay={false}
          sldeToScroll={1}
          swipeToSlide={true}
          width="100%"
          height="425px" // 600px
          sliderData={sliderNewProduct}
        />
        <ProductSlider
          title="محصولات پربازدید"
          infinite={sliderMostSeen.length > 4}
          slideCount={4}
          slideSpeed={4000}
          dots={false}
          autoplay={false}
          sldeToScroll={1}
          swipeToSlide={true}
          width="100%"
          height="425px" // 600px
          sliderData={sliderMostSeen}
        />

        {/* {homeBanner.length == 0 || !homeBanner ? (
          <Skeleton
            containerClassName="homeSliderSkeletonWrapper"
            highlightColor={Config.skeletonHighlightColor}
            className="skeleton"
          />
        ) : (
          <Banner
            imageSrc={homeBanner.image}
            imageAlt={homeBanner.title}
            title={homeBanner.title}
            content={homeBanner.content}
            link={homeBanner.link}
            buttonTitle="مشاهده"
          />
        )} */}

        <BannerImage data={homeBanner} banner={true} secondPart={false} />

        <ProductSlider
          title="محصولات پرفروش"
          infinite={sliderMostSale.length > 3}
          slideCount={4}
          slideSpeed={4000}
          dots={false}
          autoplay={false}
          sldeToScroll={1}
          swipeToSlide={true}
          width="100%"
          height="425px" // 600px
          sliderData={sliderMostSale}
        />
      </main>
    </section>
  );
};

export default React.memo(Main);
